module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-console",
    staticStyle: {
      "margin": "0 100px",
      "background": "#fff",
      "padding": "0 60px 60px"
    }
  }, [_c('tw-page-title', [_vm._v("图标及按钮")]), _vm._v(" "), _c('div', {
    staticClass: "twui-toolbar"
  }, [_c('a', {
    staticClass: "twui-btn xborder xlarge",
    on: {
      "click": function($event) {
        _vm.dialogAdd = true
      }
    }
  }, [_c('i', {
    staticClass: "twui-ico xadd"
  }), _vm._v("新增")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('tw-page-title', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("弹窗")]), _vm._v(" "), _c('a', {
    staticClass: "twui-btn xborder xlarge",
    on: {
      "click": function($event) {
        _vm.dialogAccess = true
      }
    }
  }, [_vm._v("左右选择")]), _vm._v(" "), _c('el-dialog', {
    staticClass: "twui-xmodal-base",
    attrs: {
      "title": "左右选择弹窗",
      "visible": _vm.dialogAccess,
      "size": "large",
      "close-on-click-modal": "false"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogAccess = $event
      }
    }
  }, [_c('el-transfer', {
    attrs: {
      "data": _vm.data
    },
    model: {
      value: (_vm.selectedList),
      callback: function($$v) {
        _vm.selectedList = $$v
      },
      expression: "selectedList"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "twui-btn xmain xlarge",
    on: {
      "click": function($event) {
        _vm.dialogAccess = false
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('button', {
    staticClass: "twui-btn xborder xlarge",
    on: {
      "click": function($event) {
        _vm.dialogAccess = false
      }
    }
  }, [_vm._v("取消")])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xmodify"
  }), _vm._v("修改")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xdownload"
  }), _vm._v("下载")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xdel"
  }), _vm._v("删除")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico ximport"
  }), _vm._v("导入")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xlink"
  }), _vm._v("关联角色")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xvc"
  }), _vm._v("查看审核")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xconvert"
  }), _vm._v("升级脚本")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xupgrade"
  }), _vm._v("关联角色")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "twui-btn xborder xlarge"
  }, [_c('i', {
    staticClass: "twui-ico xlock"
  }), _vm._v("重置密码")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-144a4827","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/web/style.vue
// module id = 587
// module chunks = 1